export const siteStats = {
  issue: '091',
  dateText: '2026.10.10 · 周五',
  todayUpdates: 42,
  totalMelons: 12806,
  onlineViewers: 3241,
  lastUpdate: '14:05',
};

export const navChips = [
  { id: 'feed', label: '今日快讯' },
  { id: 'rank', label: '大瓜榜' },
  { id: 'influencer', label: '网红黑料' },
  { id: 'star', label: '明星八卦' },
  { id: 'talk', label: '热评现场' },
];

export const headlineTicker = [
  '某三字顶流深夜被拍，与新剧女搭档同返公寓，工作室整夜未回应',
  '带货一姐直播间突下架全部链接，助理称“技术原因”，网友并不买账',
  '选秀女团成员疑似解约，工作室一句“已和平处理”引粉丝追问',
  '千万粉 UP 主被前员工爆料拖欠工资，聊天记录截图开始在站内流传',
  '恋综爆款 CP 被路人偶遇同游，超话一夜之间涨粉二十万',
  '影帝新片路演临时取消，主办方只留下一句“因故调整”',
];

export const headlineLead = {
  tag: '今日头条',
  title: '某三字顶流深夜被拍，工作室沉默整夜',
  summary:
    '从路人视角到同车抵达，时间线被网友整理得明明白白。截至目前，当事人与团队仍未给出任何正面回应，热搜位置却一直没掉下来。',
  meta: '热度 8.2 万 · 讨论 1,264 · 更新于 14:05',
};

export const dailyDigest = {
  title: '今天，你只需要看这一屏',
  body:
    '我们把全网的瓜按时间顺序摞在一起：谁在深夜被拍，谁在直播间翻车，谁的路演突然取消。不用来回跳，从上往下读，今天发生了什么都在这条线里。',
  points: [
    '顶流同返公寓话题连挂热搜三小时，工作室仍沉默',
    '带货一姐紧急收播，多个品牌连夜撤下宣传物料',
    '恋综 CP 被偶遇同游，评论区吵成两派',
  ],
};

export const flashFeed = [
  {
    id: 'f1',
    time: '14:05',
    tag: '明星八卦',
    title: '某三字顶流深夜被拍，与新剧女搭档同返公寓',
    summary: '小区门口蹲守的路人拍下两人同车抵达，工作室整夜未发声，话题已连上三条热搜。',
    heat: '8.2万',
    heatValue: 82000,
    comments: 1264,
    img: 'https://readdy.ai/api/search-image?query=Moody%20recording%20studio%20interior%20at%20night%20with%20warm%20amber%20lamp%20glow%2C%20blurred%20microphone%20silhouette%20in%20the%20foreground%2C%20dark%20acoustic%20panels%20in%20the%20background%2C%20cinematic%20shallow%20depth%20of%20field%2C%20warm%20editorial%20tones%2C%20no%20people&width=400&height=400&seq=melon-flash-01&orientation=squarish',
    fresh: true,
  },
  {
    id: 'f2',
    time: '13:20',
    tag: '网红黑料',
    title: '带货一姐直播间突下架全部链接，助理称“技术原因”',
    summary: '单场 GMV 刚破纪录就紧急收播，评论区刷屏“是不是又出事了”，品牌方集体沉默。',
    heat: '6.7万',
    heatValue: 67000,
    comments: 2130,
    img: 'https://readdy.ai/api/search-image?query=Glowing%20smartphone%20screen%20held%20in%20a%20dark%20room%20showing%20a%20blank%20livestream%20interface%2C%20warm%20orange%20rim%20light%2C%20blurred%20bedroom%20background%2C%20cinematic%20shallow%20depth%20of%20field%2C%20warm%20editorial%20tones%2C%20no%20text%2C%20no%20faces&width=400&height=400&seq=melon-flash-02&orientation=squarish',
    fresh: true,
  },
  {
    id: 'f3',
    time: '12:47',
    tag: '今日吃瓜',
    title: '选秀女团成员疑似解约，工作室一句“已和平处理”',
    summary: '粉丝从行程表里发现异常，超话已开始自发整理时间线，等待一个更正式的说法。',
    heat: '4.1万',
    heatValue: 41000,
    comments: 876,
    img: 'https://readdy.ai/api/search-image?query=Empty%20concert%20stage%20with%20warm%20spotlight%20beams%20cutting%20through%20haze%2C%20blurred%20seat%20rows%20in%20the%20foreground%2C%20deep%20crimson%20and%20amber%20tones%2C%20cinematic%20atmosphere%2C%20warm%20editorial%20photography%2C%20no%20people&width=400&height=400&seq=melon-flash-03&orientation=squarish',
    fresh: false,
  },
  {
    id: 'f4',
    time: '11:58',
    tag: '网红黑料',
    title: '千万粉 UP 主被前员工爆料拖欠工资',
    summary: '聊天记录与打款截图在站内流传，本人暂未回应，合作品牌已悄悄撤下置顶内容。',
    heat: '5.3万',
    heatValue: 53000,
    comments: 1542,
    img: 'https://readdy.ai/api/search-image?query=Modern%20office%20desk%20at%20night%20lit%20by%20a%20warm%20desk%20lamp%2C%20scattered%20papers%20and%20a%20closed%20laptop%2C%20blurred%20city%20lights%20through%20the%20window%20in%20the%20background%2C%20soft%20cinematic%20warm%20tones%2C%20warm%20editorial%20photography%2C%20no%20people&width=400&height=400&seq=melon-flash-04&orientation=squarish',
    fresh: false,
  },
  {
    id: 'f5',
    time: '11:12',
    tag: '热门事件',
    title: '恋综爆款 CP 被路人偶遇同游，超话一夜涨粉二十万',
    summary: '路人视角照片里的背景对上了同款景点，双方团队既没承认也没否认，氛围越来越微妙。',
    heat: '7.4万',
    heatValue: 74000,
    comments: 1980,
    img: 'https://readdy.ai/api/search-image?query=Rainy%20city%20street%20at%20night%20with%20warm%20amber%20streetlight%20reflections%20on%20wet%20asphalt%2C%20blurred%20umbrellas%20and%20soft%20neon%20glow%20in%20the%20background%2C%20cinematic%20mood%2C%20warm%20editorial%20tones%2C%20no%20clear%20faces&width=400&height=400&seq=melon-flash-05&orientation=squarish',
    fresh: false,
  },
  {
    id: 'f6',
    time: '10:26',
    tag: '明星八卦',
    title: '影帝新片路演临时取消，主办方只发一句“因故调整”',
    summary: '场次前两小时通知退票，影院大屏还挂着海报，粉丝在门口合照留了个纪录。',
    heat: '3.6万',
    heatValue: 36000,
    comments: 642,
    img: 'https://readdy.ai/api/search-image?query=Red%20carpet%20area%20with%20warm%20golden%20lights%20and%20blurred%20velvet%20ropes%2C%20dark%20elegant%20theater%20entrance%20in%20the%20background%2C%20cinematic%20shallow%20depth%20of%20field%2C%20warm%20editorial%20tones%2C%20no%20people&width=400&height=400&seq=melon-flash-06&orientation=squarish',
    fresh: false,
  },
  {
    id: 'f7',
    time: '09:40',
    tag: '今日吃瓜',
    title: '综艺未剪片段流出，两位常驻嘉宾关系成谜',
    summary: '片段来自现场观众手机，画质一般但信息量不小，节目组暂未回应剪辑争议。',
    heat: '2.9万',
    heatValue: 29000,
    comments: 508,
    img: 'https://readdy.ai/api/search-image?query=Small%20variety%20show%20green%20room%20with%20glowing%20monitors%20and%20warm%20practical%20lamps%2C%20blurred%20cables%20and%20folding%20chairs%20in%20the%20background%2C%20cinematic%20warm%20tones%2C%20warm%20editorial%20photography%2C%20no%20people&width=400&height=400&seq=melon-flash-07&orientation=squarish',
    fresh: false,
  },
];

export const melonRanking = [
  { rank: 1, title: '顶流深夜同返公寓，工作室沉默整夜', tag: '明星八卦', heat: '8.2万', delta: 'up', deltaText: '+312%' },
  { rank: 2, title: '恋综 CP 被偶遇同游，超话一夜涨粉', tag: '热门事件', heat: '7.4万', delta: 'up', deltaText: '+186%' },
  { rank: 3, title: '带货一姐紧急收播，链接全部下架', tag: '网红黑料', heat: '6.7万', delta: 'new', deltaText: '新上榜' },
  { rank: 4, title: '千万粉 UP 主被曝拖欠工资', tag: '网红黑料', heat: '5.3万', delta: 'up', deltaText: '+64%' },
  { rank: 5, title: '女团成员疑似解约，工作室回应含糊', tag: '今日吃瓜', heat: '4.1万', delta: 'down', deltaText: '-12%' },
  { rank: 6, title: '影帝新片路演临时取消', tag: '明星八卦', heat: '3.6万', delta: 'steady', deltaText: '持平' },
];

export const influencerStories = [
  {
    id: 'i1',
    handle: '@甜甜圈没在怕',
    tag: '直播翻车',
    title: '直播中途黑屏十分钟，回来只留一句“今天先到这”',
    summary: '当晚同款链接陆续下架，合作品牌连夜删除宣传物料，粉丝群已经开始互撕。',
    reads: '12.6万',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20home%20livestream%20setup%20with%20a%20ring%20light%20and%20warm%20orange%20glow%2C%20blurred%20cosmetics%20and%20snacks%20on%20the%20desk%2C%20soft%20bedroom%20background%2C%20cinematic%20warm%20tones%2C%20warm%20editorial%20photography%2C%20no%20faces&width=600&height=600&seq=melon-inf-01&orientation=squarish',
  },
  {
    id: 'i2',
    handle: '@搬砖的小吴',
    tag: '劳资纠纷',
    title: '前员工放出聊天记录，称半年工资只发过两次',
    summary: '截图里的对话时间线很完整，当事人暂未回应，评论区已出现多名自称前同事的网友。',
    reads: '9.3万',
    img: 'https://readdy.ai/api/search-image?query=Stack%20of%20unopened%20delivery%20parcels%20beside%20a%20warm%20desk%20lamp%20in%20a%20dim%20room%2C%20blurred%20shelves%20in%20the%20background%2C%20cinematic%20warm%20tones%2C%20warm%20editorial%20photography%2C%20no%20people&width=600&height=600&seq=melon-inf-02&orientation=squarish',
  },
  {
    id: 'i3',
    handle: '@深夜食堂日记',
    tag: '内容争议',
    title: '探店视频被商家指出是摆拍，双方各执一词',
    summary: '商家放出监控称当天并未接待，博主回应“素材混剪，属于行业惯例”，争议仍在升级。',
    reads: '6.8万',
    img: 'https://readdy.ai/api/search-image?query=Small%20restaurant%20table%20set%20for%20a%20food%20shoot%20with%20warm%20tungsten%20light%2C%20blurred%20menus%20and%20plates%20in%20the%20background%2C%20cinematic%20warm%20tones%2C%20warm%20editorial%20photography%2C%20no%20people&width=600&height=600&seq=melon-inf-03&orientation=squarish',
  },
];

export const starStories = [
  {
    id: 's1',
    name: '三字顶流 · 待回应',
    tag: '明星八卦',
    title: '深夜同返公寓，工作室整夜不发一言',
    summary: '路人视角下两人同车抵达小区，热搜已经连挂三个小时，粉丝与路人各说各话。',
    reads: '28.4万',
    img: 'https://readdy.ai/api/search-image?query=Backstage%20dressing%20room%20mirror%20framed%20with%20warm%20bulbs%2C%20scattered%20flowers%20and%20script%20pages%20on%20the%20counter%2C%20blurred%20dark%20corridor%20in%20the%20background%2C%20cinematic%20golden%20tones%2C%20warm%20editorial%20photography%2C%20no%20people&width=600&height=600&seq=melon-star-01&orientation=squarish',
  },
  {
    id: 's2',
    name: '选秀女团成员',
    tag: '明星八卦',
    title: '解约传闻持续发酵，行程表上出现大片空白',
    summary: '官方那句“已和平处理”没能止住猜测，超话里粉丝自发整理出一整条时间线。',
    reads: '11.2万',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20hotel%20corridor%20at%20night%20with%20warm%20wall%20sconces%20and%20long%20soft%20shadows%2C%20blurred%20doorway%20at%20the%20far%20end%2C%20cinematic%20amber%20tones%2C%20warm%20editorial%20photography%2C%20no%20people&width=600&height=600&seq=melon-star-02&orientation=squarish',
  },
  {
    id: 's3',
    name: '影帝 · 新片路演',
    tag: '明星八卦',
    title: '路演临时取消，影院大屏海报还没来得及撤',
    summary: '场次前两小时通知退票，“因故调整”四个字成了当晚评论区里被提起最多的一句话。',
    reads: '7.9万',
    img: 'https://readdy.ai/api/search-image?query=Film%20set%20clapperboard%20and%20a%20director%20chair%20under%20a%20warm%20tungsten%20spotlight%2C%20blurred%20dark%20studio%20background%2C%20cinematic%20amber%20tones%2C%20warm%20editorial%20photography%2C%20no%20text%2C%20no%20people&width=600&height=600&seq=melon-star-03&orientation=squarish',
  },
];

export const hotComments = [
  { id: 'c1', user: '瓜田里的猹', initial: '猹', tone: 'primary', time: '3 分钟前', content: '蹲到半夜就是为了这一口，结果工作室一句话都没有，急死个人。', likes: 1284, replies: 96 },
  { id: 'c2', user: '今天也在吃瓜', initial: '瓜', tone: 'accent', time: '12 分钟前', content: '先别急着站队，这种事儿反转率太高了，让子弹飞一会儿。', likes: 942, replies: 58 },
  { id: 'c3', user: '理性吃瓜代表', initial: '理', tone: 'secondary', time: '28 分钟前', content: '时间线整理得挺清楚的，但还是希望双方能出来给个正式说法。', likes: 611, replies: 33 },
  { id: 'c4', user: '前排搬小板凳', initial: '凳', tone: 'primary', time: '1 小时前', content: '这瓜有点大，我先收藏了，上班摸鱼的时候再慢慢看。', likes: 488, replies: 21 },
  { id: 'c5', user: '只吃瓜不带节奏', initial: '静', tone: 'accent', time: '2 小时前', content: '别扒素人、别上升家人，吃瓜归吃瓜，这条线别越过去。', likes: 1533, replies: 120 },
];